import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { selectors as appSelectors } from '../features/app'

const Loading: React.FC = () => {
  const isLoading = useSelector(appSelectors.getAppIsLoading);

  return (
    <Fragment>
      <div className={`i-loading ${isLoading ? 'i-show' : ''}`}>
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>
    </Fragment>
  )
}

export default Loading
